import { render } from "./AnnualEligibilityDeclaration.vue?vue&type=template&id=21d07bda"
import script from "./AnnualEligibilityDeclaration.vue?vue&type=script&lang=js"
export * from "./AnnualEligibilityDeclaration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__